import { render, staticRenderFns } from "./SyncUsersAlert.vue?vue&type=template&id=155c5db6"
import script from "./SyncUsersAlert.vue?vue&type=script&lang=js"
export * from "./SyncUsersAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports